import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EncrDecrService } from './encr-decr.service';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  addEventAPIuri: string = 'event/create';
  eventDetailsAPIuri: string = 'event/detail'
  getAllEventsAPIuri: string = 'event/all-events';
  getMyEventsAPIuri: string = 'event/my-events';
  cancelEventAPIuri: string = 'event/cancel/';
  bookEventAPIuri: string = 'event/bookevent';
  myBookedEventsAPIuri: string = 'event/bookevents';

  constructor(private http: HttpClient,
    private EncDecService: EncrDecrService) { }

  addEvent(data) {
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + this.addEventAPIuri, data, { headers: headers_object }).toPromise();
  }

  getEvent(id) {
    let data = {
      "link":id
      }
    return this.http.post(environment.apiURI + this.eventDetailsAPIuri,data).toPromise();
  }

  getAllEvents(eventData) {
    return this.http.post(environment.apiURI + this.getAllEventsAPIuri, eventData
    ).toPromise();
  }

  getMyEvents() {
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + this.getMyEventsAPIuri, {}, { headers: headers_object }
    ).toPromise();
  }

  cancelEvent(id) {
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + this.cancelEventAPIuri + id, {}, { headers: headers_object }).toPromise()
  }

  bookEvent(data) {
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + this.bookEventAPIuri, data, { headers: headers_object }).toPromise()
  }

  myBookedEvents() {
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.get(environment.apiURI + this.myBookedEventsAPIuri, { headers: headers_object }).toPromise()
  }

  updateEvent(event, data) {
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'event/update/'+event, data, { headers: headers_object }).toPromise()
  }

  rateEvent(event_id, rating){
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'event-rate', {event_id, rating}, { headers: headers_object }).toPromise()
  }

  pickEvent(data){
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'user/pick-it', data, { headers: headers_object }).toPromise()
  }

  unPickEvent(data){
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'user/un-pick-it', data, { headers: headers_object }).toPromise()
  }

  myPickedEvents(){
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.get(environment.apiURI + 'user/myPickedEvents', { headers: headers_object }).toPromise()
  }

}
